import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Token storage strategy
// ----------------------
// Primary auth = httpOnly secure cookie set by the backend (immune to XSS).
// We ALSO keep a Bearer-token copy in sessionStorage as a fallback for
// environments where third-party cookies are blocked (e.g. sandboxed preview
// iframes). sessionStorage was chosen over localStorage so the token does
// not survive a browser/tab close — shrinking the XSS window.
const TOKEN_KEY = "dsl_access_token";

export const setToken = (t) => {
  if (t) sessionStorage.setItem(TOKEN_KEY, t);
  else sessionStorage.removeItem(TOKEN_KEY);
};
export const getToken = () => sessionStorage.getItem(TOKEN_KEY);

client.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export default client;

export const formatApiErrorDetail = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
